import { trackerConfig } from "../config";
import type { Tracker } from "../types";

/**
 * Google Analytics 4 (gtag.js). Injected only after the user grants the
 * "analytics" category. No-op when `VITE_GA_MEASUREMENT_ID` is blank.
 *
 * Revocation note: gtag cannot be unloaded once injected — revoking analytics
 * only prevents future loads; the script clears on the next page reload.
 */
let loaded = false;

export const googleAnalytics: Tracker = {
  id: "google-analytics",
  category: "analytics",
  label: "Google Analytics",
  isConfigured(): boolean {
    return trackerConfig.gaMeasurementId.length > 0;
  },
  load(): void {
    if (loaded || !this.isConfigured()) return;
    loaded = true;
    const id = trackerConfig.gaMeasurementId;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    // Canonical gtag shim: push each call's args onto the dataLayer queue that
    // gtag.js drains once it finishes loading.
    const gtag: typeof window.gtag = (...args: unknown[]) => {
      window.dataLayer!.push(args);
    };
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", id);
  },
};
